<template>
  <v-app>
    <div v-if='this.$route.path !== "/login"' >
       <navigation/>
    </div>
    <v-content>
      <v-container grid-list-md fluid style="padding: 0px;" >
         <div v-if='this.$route.path !== "/login"' class="bg-white">
          <v-layout row wrap>
             <v-flex xs12 sm6 md3>
                <v-img 
                  :src="require('./assets/images/MarathonInnova-text-logo.png')"
                  width="190"
                  height="30"
                  class="company_logo"
                ></v-img>
              
            </v-flex>
          </v-layout>
          </div> 
       <v-container grid-list-md fluid style="padding-top: 0px;" >
        <router-view :key="$route.fullPath"></router-view>
       </v-container>
      </v-container>
    </v-content>
 <v-footer padless>
    <v-col class="text-center" cols="12"  >           
      &#9400; {{ new Date().getFullYear() }} — Designed and Developed by 
      <a href="https://www.cdpindia.com/" target='_blank'>CDP India Pvt. Ltd</a>
    </v-col>
  </v-footer>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import navigation from '../src/navigation';
import firebase, { messaging } from 'firebase';
export default {
   name: 'App',
   computed: { ...mapGetters(['get_access_token','get_user']),   },
   components: { navigation },
  data: () => ({
    loaders: {
      global_search_loader: false
    },
    firebase_token:'',
    list:[],
    padless: false,
    variant: 'fixed',
    user:'',
    global_search_select: null,
    global_search_query: null,
    global_search_items: [],
    logo_width: "100",
    dialog: false,
    role:'',
    drawer: true,
    mini: false,
    search_timer: null,
    default_image_path: "/images/default_user.png",
    bars: [
        { class: '' },
        { class: '', dark: true },
        { class: 'primary', dark: true },
        { class: 'elevation-0' },
      ],
    items: [],
  }),
};
</script>
<style>
 @import './assets/css/style.css';
</style>
